import { useQuery } from '@tanstack/react-query';
import AxiosInstance from '../utils/AxiosInstance.jsx';
import { handleResponse } from '../utils';

const useContract = (data) => {
  return useQuery({
    queryKey: ['contract', data],
    queryFn: async () => handleResponse(await AxiosInstance.post('/internal_api/tunnel/contract', data)),
    staleTime: Infinity,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    placeholderData: (prev) => prev ?? [],
  });
};

export { useContract };
